import {
  Component,
} from '@angular/core';
@Component({
  templateUrl: 'dgx-home.component.html'
})
export class DGXHomeComponent {}
